import { RefreshCw } from 'lucide-react';
import { useBuildVersion } from '@/hooks/use-build-version';

/**
 * Tells the user their tab is running an outdated build, and reloads it.
 *
 * Deliberately not dismissible: an outdated bundle is the one state where
 * "everything looks fine" is actively misleading — the user sees a bug that is
 * already fixed, and reporting it costs everyone a round trip (hub #160). The
 * banner disappears the moment they reload.
 */
export function NewVersionBanner() {
  const { updateAvailable, reload } = useBuildVersion();

  if (!updateAvailable) return null;

  return (
    <div
      role="status"
      className="flex items-center gap-3 border-b border-primary/30 bg-primary/10 px-4 py-2.5 text-sm text-foreground"
    >
      <RefreshCw className="h-4 w-4 shrink-0 text-primary" aria-hidden />
      <p className="min-w-0 flex-1 font-medium">
        A new version of LarkPM is available. Reload to get the latest fixes.
      </p>
      <button
        type="button"
        onClick={reload}
        className="shrink-0 rounded-md bg-primary px-3 py-1.5 text-xs font-semibold text-primary-foreground hover:bg-primary/90"
      >
        Reload
      </button>
    </div>
  );
}
